import React from 'react';
import styled from 'styled-components';

import ShoreLogoSVG from 'assets/images/logo_shore.svg?url';

const LogoWrapper = styled.div<Props>`
  height: 33px;
  margin: 20px;
  overflow: hidden;
  text-align: ${({ collapsed }) => (collapsed ? 'left' : 'center')};
  width: ${({ collapsed }) => (collapsed ? '32px' : 'auto')};
  padding: ${({ padding }) => padding ?? '0'};
  padding-right: ${({ collapsed, padding }) => {
    if (padding) return undefined;
    return collapsed ? '0' : '90px';
  }};
`;

interface Props {
  collapsed?: boolean;
  padding?: string;
}

const Logo: React.FC<Props> = ({ collapsed = false, padding }) => (
  <LogoWrapper collapsed={collapsed} padding={padding}>
    <img src={ShoreLogoSVG} alt="Shore Logo" height={33} />
  </LogoWrapper>
);

export default Logo;
